import { render, staticRenderFns } from "./BatchProcess.vue?vue&type=template&id=619c68f5&scoped=true&"
import script from "./BatchProcess.vue?vue&type=script&lang=js&"
export * from "./BatchProcess.vue?vue&type=script&lang=js&"
import style0 from "./BatchProcess.vue?vue&type=style&index=0&id=619c68f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619c68f5",
  null
  
)

export default component.exports